module.exports = __webpack_public_path__ + "static/img/9.836e074.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/9.png
// module id = 8f6k
// module chunks = 0